import { useNavigate } from "react-router-dom";
import { uploadMentionsHref } from "@/features/mentions/upload-mentions-link";
import { UploadsPage } from "@/features/uploads/UploadsPage";
import { useAppShell } from "@/shell/app-shell-context";
import { ApiState } from "@/shared/components/ApiState";
import { useRequireCompany } from "@/shared/hooks/useRequireCompany";
import { hasRoleAtLeast } from "@/shared/utils/roles";

export function UploadsRoute() {
  const navigate = useNavigate();
  const { token, profile } = useAppShell();
  const company = useRequireCompany();

  if (!company) return null;
  // Mesmo papel que a API exige pra enviar e corrigir uploads (2026-10-24).
  if (!hasRoleAtLeast(profile, "technician")) {
    return <ApiState kind="error">Os uploads são de Técnico ou acima.</ApiState>;
  }

  // A tela busca os próprios dados no contrato real do web_api — o
  // escopo por empresa viaja na credencial (header/token), nunca em prop.
  return (
    <UploadsPage
      token={token}
      uploadHref={uploadId => `/empresas/${company.id}/uploads/${uploadId}`}
      mentionsHref={uploadId => uploadMentionsHref(company.id, uploadId)}
      onOpenDownloads={() => navigate(`/empresas/${company.id}/downloads`)}
    />
  );
}
